import { render, staticRenderFns } from "./TheMarriageApplication.vue?vue&type=template&id=0d92aeed&"
import script from "./TheMarriageApplication.vue?vue&type=script&lang=js&"
export * from "./TheMarriageApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports